<div class="chart-container">
    <div class="chart-title">Expected vs Active Patients</div>
    <p-chart type="line" [data]="data" [options]="options"></p-chart>
</div>